import * as types from '../types';
import { IInvoicesApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class InvoicesHttpApi extends HttpApi implements IInvoicesApi {
  async listInvoices(page = 1, limit = 20, filters: types.InvoiceListFilters = {}): Promise<types.PaginatedResponse<types.Invoice>> {
    const response = await this.http.get<types.PaginatedResponse<types.Invoice>>(
      '/invoices',
      { params: { page, limit, ...filters } }
    );
    return response.data;
  }

  async getInvoice(id: string): Promise<types.Invoice> {
    const response = await this.http.get<types.APIResponse<types.Invoice>>(`/invoices/${id}`);
    return response.data.data;
  }

  async createInvoice(data: types.CreateInvoiceRequest): Promise<types.Invoice> {
    const response = await this.http.post<types.APIResponse<types.InvoiceCreationResult>>('/invoices', data);
    return response.data.data.data;
  }

  async previewInvoice(data: types.CreateInvoiceRequest): Promise<types.InvoicePreview> {
    const response = await this.http.post<types.APIResponse<types.InvoicePreview>>('/invoices/preview', data);
    return response.data.data;
  }

  async updateInvoice(id: string, data: types.UpdateInvoiceRequest): Promise<types.Invoice> {
    const response = await this.http.patch<types.APIResponse<types.Invoice>>(`/invoices/${id}`, data);
    return response.data.data;
  }

  async sendInvoice(id: string): Promise<types.Invoice> {
    const response = await this.http.post<types.APIResponse<types.Invoice>>(`/invoices/${id}/send`);
    return response.data.data;
  }

  async cancelInvoice(id: string, memo?: string): Promise<types.Invoice> {
    const response = await this.http.post<types.APIResponse<types.Invoice>>(`/invoices/${id}/cancel`, memo ? { memo } : {});
    return response.data.data;
  }

  async regenerateInvoicePortalCode(id: string): Promise<types.Invoice> {
    const response = await this.http.post<types.APIResponse<types.Invoice>>(`/invoices/${encodeURIComponent(id)}/portal-code/regenerate`);
    return response.data.data;
  }
}
